import * as React from 'react';

export function SvgOutlook(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M14.2645 6.81636V10.3373L15.5085 11.112C15.5413 11.1215 15.6125 11.1222 15.6453 11.112L20.9993 7.54177C20.9993 7.11923 20.6008 6.81635 20.3759 6.81635H14.2645V6.81636Z"
        fill="#0072C6"
      />
      <path
        d="M14.2645 11.6508L15.3998 12.4222C15.5598 12.5385 15.7525 12.4222 15.7525 12.4222C15.5604 12.5385 21 8.96487 21 8.96487V15.4361C21 16.1405 20.544 16.436 20.0314 16.436H14.2638V11.6508H14.2645Z"
        fill="#0072C6"
      />
      <path
        d="M8.38623 10.0276C7.99935 10.0276 7.69108 10.2074 7.46347 10.5664C7.23585 10.9254 7.1217 11.4007 7.1217 11.9922C7.1217 12.5926 7.23585 13.0672 7.46347 13.416C7.69108 13.7655 7.98978 13.9393 8.35889 13.9393C8.73961 13.9393 9.04173 13.7696 9.26456 13.4302C9.48739 13.0908 9.59949 12.6196 9.59949 12.0173C9.59949 11.3892 9.49149 10.9004 9.27481 10.5509C9.05814 10.202 8.76217 10.0276 8.38623 10.0276Z"
        fill="#0072C6"
      />
      <path
        d="M3 5.02817V18.8028L13.5947 21V3L3 5.02817ZM10.0895 14.2442C9.64183 14.8269 9.0581 15.119 8.33766 15.119C7.63568 15.119 7.06425 14.8364 6.62201 14.2719C6.18045 13.7067 5.95899 12.9712 5.95899 12.0639C5.95899 11.1059 6.18319 10.3312 6.63226 9.7396C7.08134 9.14806 7.67601 8.85194 8.41627 8.85194C9.11552 8.85194 9.68148 9.13453 10.1128 9.70107C10.5448 10.2676 10.7608 11.014 10.7608 11.9408C10.7614 12.8934 10.5373 13.6614 10.0895 14.2442Z"
        fill="#0072C6"
      />
    </svg>
  );
}
